document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('take-me-there-')
  if (!root) return
  const sliderEl = root.querySelector('.centered-slider')
  const track = root.querySelector('.centered-slider .slider-track')
  if (!sliderEl || !track) return
  const cursor = document.getElementById('slide-cursor-')
  const realSlides = Array.from(track.querySelectorAll('.slide'))
  const total = realSlides.length
  // ── Clone ALL slides and bookend: [...realSlides, ...realSlides, ...realSlides]
  // This ensures both sides always have visible content
  const beforeClones = realSlides.map(s => {
    const c = s.cloneNode(true)
    c.dataset.clone = 'before'
    return c
  })
  const afterClones = realSlides.map(s => {
    const c = s.cloneNode(true)
    c.dataset.clone = 'after'
    return c
  })
  // Prepend before-clones (in order), append after-clones
  beforeClones.reverse().forEach(c => track.insertBefore(c, track.firstChild))
  afterClones.forEach(c => track.appendChild(c))
  // Now DOM order: [clone-0..clone-N, real-0..real-N, clone-0..clone-N]
  // Real slides start at DOM index = total
  const slides = Array.from(track.querySelectorAll('.slide'))
  slides.forEach((s, i) => s.dataset.index = i)
  let index = total        // start on real slide 0 (offset by one full set of clones)
  let currentOffset = 0
  let isWarping = false
  let isOverNonActive = false
  function hideCursor() {
    if (cursor && cursor.classList.contains('is-visible')) {
      cursor.style.transition = 'opacity .15s ease, transform .12s ease'
      setTimeout(() => {
        cursor.classList.remove('is-visible', 'is-left', 'is-right', 'is-down')
        if (scope) scope.classList.remove('cursor-hidden')
        isOverNonActive = false
      }, 100)
    }
  }
  function getOffset(idx) {
    const active = slides[idx]
    if (!active) return currentOffset
    const trackWidth = track.clientWidth
    const activeWidth = active.clientWidth
    return -(active.offsetLeft - (trackWidth - activeWidth) / 2)
  }
  const update = (animate = true) => {
    track.style.transition = animate ? 'transform 0.3s ease' : 'none'
    // Active class on real slides only
   const realIndex = ((index % total) + total) % total
slides.forEach((s, i) => {
  const slideRealIndex = i % total
  const isActive = slideRealIndex === realIndex
  s.classList.toggle('active', isActive)
  const vids = s.querySelectorAll('video')
  vids.forEach(v => {
  if (isActive) {
    v.muted = true
    v.playsInline = true
    const p = v.play?.()
    if (p?.catch) p.catch(() => {})
  } else {
    v.muted = true
  }
})
})
    const clampedReal = Math.max(0, Math.min(realIndex, total - 1))
    root.style.setProperty('--active-slide', `${clampedReal}`)
    const offset = getOffset(index)
    currentOffset = offset
    track.style.transform = `translate3d(${offset}px,0,0)`
    root.style.setProperty('--current-offset', `${currentOffset}`)
    const trackWidth = track.clientWidth
    root.style.setProperty('--track-width', `${trackWidth}`)
    track.style.setProperty('--track-width', `${trackWidth}`)
    track.classList.remove('moving-track')
    slides.forEach(slide => {
      slide.style.setProperty('--slide-left', `${slide.offsetLeft}`)
      slide.style.setProperty('--slide-width', `${slide.clientWidth}`)
    })
    // Progress bar
    const progressBar = root.querySelector('.custom-progress__bar')
    if (progressBar) {
      progressBar.style.width = `${(clampedReal + 1) / total * 100}%`
    }
    // ── Warp after transition ────────────────────────────────────
    if (!animate || isWarping) return
    // Went into after-clones → warp back to real slides
    if (index > total * 2 - 1) {
      isWarping = true
      setTimeout(() => {
        index = index - total   // same position in real slides
        track.style.transition = 'none'
        const off = getOffset(index)
        currentOffset = off
        track.style.transform = `translateX(${off}px)`
        root.style.setProperty('--current-offset', `${off}`)
        requestAnimationFrame(() => requestAnimationFrame(() => {
          track.style.transition = 'transform 0.6s ease'
          isWarping = false
        }))
      }, 610)
    }
    // Went into before-clones → warp forward to real slides
    if (index < 1) {
      isWarping = true
      setTimeout(() => {
        index = index + total   // same position in real slides
        track.style.transition = 'none'
        const off = getOffset(index)
        currentOffset = off
        track.style.transform = `translateX(${off}px)`
        root.style.setProperty('--current-offset', `${off}`)
        requestAnimationFrame(() => requestAnimationFrame(() => {
          track.style.transition = 'transform 0.6s ease'
          isWarping = false
        }))
      }, 610)
    }
  }
  // ── Click ────────────────────────────────────────────────────────
  sliderEl.addEventListener('click', () => {
    if (!cursor || !cursor.classList.contains('is-visible')) return
    const prevIndex = index
    if (cursor.classList.contains('is-right')) index++
    else index--
    if (index !== prevIndex) update()
  })
  window.addEventListener('resize', () => update(false))
  setTimeout(() => update(false), 500)
  // ── rafThrottle ──────────────────────────────────────────────────
  function rafThrottle(fn) {
    let ticking = false, lastArgs, lastThis
    return function (...args) {
      lastArgs = args; lastThis = this
      if (!ticking) {
        ticking = true
        requestAnimationFrame(() => { fn.apply(lastThis, lastArgs); ticking = false })
      }
    }
  }
  // ── Swipe ────────────────────────────────────────────────────────
  function attachSwipe(el, options = {}) {
    const threshold = Number(el.dataset.swipeThreshold || options.threshold || 30)
    const restraint = Number(el.dataset.swipeRestraint || options.restraint || 120)
    let startX = 0, startY = 0, pointerId = null, tracking = false
    function onPointerDown(e) {
      pointerId = e.pointerId; startX = e.clientX; startY = e.clientY; tracking = true
    }
    function onPointerUp(e) {
      track.style.transition = 'transform 0.3s ease'
      if (!tracking) return
      tracking = false
      try { if (pointerId != null) el.releasePointerCapture(pointerId) } catch (_) {}
      pointerId = null
      const dx = e.clientX - startX
      const dy = e.clientY - startY
      if (Math.abs(dx) >= threshold && Math.abs(dy) <= restraint) {
        if (dx < 0) options.onSwipe?.('left', e)
        else options.onSwipe?.('right', e)
      }
    }
    function onPointerMove(e) {
      if (!tracking) return
      const dx = e.clientX - startX
      track.style.transition = 'none'
      if (Math.abs(dx) > 50) track.classList.add('moving-track')
      track.style.transform = `translateX(${currentOffset + dx}px)`
      root.style.setProperty('--current-offset', `${currentOffset + dx}`)
    }
    function onPointerCancel() {
      tracking = false; pointerId = null
      track.classList.remove('moving-track')
      track.style.transition = 'transform 0.6s ease'
      track.style.transform = `translateX(${currentOffset}px)`
      root.style.setProperty('--current-offset', `${currentOffset}`)
    }
    const onMove = rafThrottle(onPointerMove)
    el.addEventListener('pointerdown', onPointerDown, { passive: true })
    el.addEventListener('pointermove', onMove, { passive: true })
    el.addEventListener('pointerup', onPointerUp, { passive: false })
    el.addEventListener('pointercancel', onPointerCancel, { passive: true })
  }
  // ── Wheel ────────────────────────────────────────────────────────
  function attachWheelSwipe(scope, { threshold=60, intent=8, idle=50, onSwipe } = {}) {
    let accX = 0, consumed = false, idleTimer = null
    const endGesture = () => { accX = 0; consumed = false; if (idleTimer) { clearTimeout(idleTimer); idleTimer = null } }
    const onWheel = (e) => {
      const dx = e.deltaX || 0, dy = e.deltaY || 0
      if (Math.abs(dx) * 2 <= Math.abs(dy)) return
      e.preventDefault(); e.stopPropagation()
      accX += dx
      const dir = accX > 0 ? 'left' : 'right'
      if ((Math.abs(accX) >= intent || consumed) && e.cancelable) { e.preventDefault(); e.stopPropagation() }
      if (!consumed && Math.abs(accX) >= threshold) {
        onSwipe?.(dir)
        consumed = true; accX = 0
      }
      if (idleTimer) clearTimeout(idleTimer)
      idleTimer = setTimeout(endGesture, idle)
    }
    scope.addEventListener('wheel', onWheel, { passive: false })
  }
  const scope = root.querySelector('[data-cursor-scope]')
  if (scope) {
    if (!scope.style.touchAction) scope.style.touchAction = 'pan-y'
    attachSwipe(scope, {
      threshold: 30, restraint: 500,
      onSwipe: (dir) => {
        if (dir === 'left') index++
        else index--
        update()
      },
    })
    attachWheelSwipe(scope, {
      threshold: 30,
      onSwipe: (dir) => {
        const prev = index
        if (dir === 'left') index++
        else index--
        if (index !== prev) update()
      },
    })
  }
  // ── Cursor ───────────────────────────────────────────────────────
  if (!window.matchMedia('(hover: none)').matches && scope) {
    if (!cursor) return
    function setCursorDirection(isLeft) {
      cursor.classList.toggle('is-left', isLeft)
      cursor.classList.toggle('is-right', !isLeft)
    }
    function showCursorAt(x, y) {
      cursor.style.transform = `translate(${x}px, ${y}px) translate(-50%, -50%)`
      if (!cursor.classList.contains('is-visible')) {
        cursor.style.transition = 'opacity .15s ease, transform .12s ease'
        setTimeout(() => {
          cursor.classList.add('is-visible')
          setTimeout(() => { cursor.style.transition = 'none' }, 200)
        }, 100)
      }
    }
    function onPointerMove(e) {
      if (cursor.classList.contains('is-down')) return
      const slide = e.target.closest('.slide')
      if (!slide) { hideCursor(); return }
      const slideIndex = +slide.dataset.index
      if (slideIndex === index) { hideCursor(); return }
      isOverNonActive = true
      scope.classList.add('cursor-hidden')
      setCursorDirection(slideIndex < index)
      showCursorAt(e.clientX, e.clientY)
    }
    function onPointerLeave() { hideCursor() }
    function onPointerDown() { if (!isOverNonActive) return; cursor.classList.add('is-down') }
    function onPointerUp() { setTimeout(() => cursor.classList.remove('is-down'), 100) }
    const onMove = rafThrottle(onPointerMove)
    const onLeave = rafThrottle(onPointerLeave)
    scope.addEventListener('pointerenter', onPointerMove)
    scope.addEventListener('pointermove', onMove, { passive: true })
    scope.addEventListener('pointerleave', onLeave, { passive: true })
    scope.addEventListener('pointerdown', onPointerDown)
    scope.addEventListener('pointerup', onPointerUp)
    window.addEventListener('blur', hideCursor)
  }
})